import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
} from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import { I18n } from "@aws-amplify/core";

function MoreActionsDialog({ open, onClose, onAddRemark, onCloseAlarm, onSuspend, language }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h6" align="center">
        {I18n.get("Take more actions on the selected alarms")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              startIcon={<AddCommentIcon />}
              onClick={onAddRemark}
            >
               {I18n.get("Add Remark")}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              startIcon={<AlarmOffIcon />}
              onClick={onCloseAlarm}
            >
              {I18n.get("Close Alarm")}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              startIcon={<PauseCircleOutlineIcon />}
              onClick={onSuspend}
            >
               {I18n.get("Suspend Alarm")}
              
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} startIcon={<CancelIcon />}>
        {I18n.get("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoreActionsDialog;